export const layoutsMisc = {
  confirm: {
    defaultTitle: "Êtes-vous sûr ?",
    confirm: "Confirmer",
    cancel: "Annuler",
  },
  navPluginWeb: {
    title: "Créer un site web",
    stepOf: "{step} sur 5",
  },
  saMenu: {
    title: "Actions système",
    subtitle: "Panneau d'automatisations",
    sectionComms: "COMMUNICATIONS",
    firstCheckin: "Envoyer lors du premier check-in",
  },
  systemActions: {
    checkin: "Check-in",
  },
  regionMessage: {
    text: "Contactez l'équipe d'assistance pour configurer la connexion.",
    contactSupport: "Contacter l'assistance",
  },
  selectionScanner: {
    title: "Choisissez le type de document à scanner",
    idCard: "Carte d'identité",
    passport: "Passeport",
  },
};
